// extracted by mini-css-extract-plugin
export var sm = "768";
export var md = "1024";
export var lg = "1280";
export var xl = "1600";
export var wrapper = "AppointmentTypesList-module--wrapper--0uUPz";
export var item = "AppointmentTypesList-module--item--hf8kd";
export var bordered = "AppointmentTypesList-module--bordered--hvgmN";
export var otherItem = "AppointmentTypesList-module--otherItem--pBn9k";